import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  //   Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "2022", value: 22 },
  { name: "2023", value: 26 },
  { name: "2024", value: 29 },
  { name: "2025", value: 32 },
  { name: "2026", value: 38 },
  { name: "2027", value: 41 },
  { name: "2028", value: 46 },
  { name: "2029", value: 50 },
];

// const renderCustomTooltip = ({ payload }) => {
//   if (payload && payload.length > 0) {
//     const dataPoint = payload[0].payload;
//     return (
//       <div className="custom-tooltip">
//         <p>{dataPoint.name}</p>
//         <p
//           style={{ color: "rgb(53, 162, 235)" }}
//         >{`Number of global active device connections in billions: ${dataPoint.value}`}</p>
//       </div>
//     );
//   }
//   return null;
// };

const HmcConnectedDevicesChart = () => {
  return (
    <div>
      <div className="ml-16 mb-7">
        <p className="text-left text-base font-bold mb-0">
          Number of global active device connections
        </p>
        <span>(Billions)</span>
        <sup className="text-[10px]">1</sup>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" />
          <YAxis />
          {/* <Tooltip content={renderCustomTooltip} /> */}
          {/* <Tooltip /> */}
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="#C39F5C"
            animationBegin={500}
            animationDuration={1000}
            barSize={15}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HmcConnectedDevicesChart;
